import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const CalendarModule = lazy(loadModule);

export default CalendarModule;
